import React from "react";
import { Modal as BootstrapModal } from "react-bootstrap";

export default function Modal({ show, onHide, header, children }) {
  return (
    <>
      <BootstrapModal
        className="student inmodal auto without-overflow"
        show={show}
        onHide={onHide}
      >
        <BootstrapModal.Header>
          <button onClick={onHide} className="close" type="button">
            <span aria-hidden="true">&times;</span>
            <span className="sr-only">Close</span>
          </button>
          <BootstrapModal.Title>{header}</BootstrapModal.Title>
        </BootstrapModal.Header>
        <BootstrapModal.Body> {children}</BootstrapModal.Body>
      </BootstrapModal>
    </>
  );
}
